import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AssetTransferEntryRoutingModule } from './asset-transfer-entry-routing.module';
import { AssetTransferEntryLinkComponent } from './asset-transfer-entry-link/asset-transfer-entry-link.component';
import { AssetTransferEntryLandingPageComponent } from './asset-transfer-entry-landing-page/asset-transfer-entry-landing-page.component';
import { AssetTransferEntryDetailsComponent } from './asset-transfer-entry-details/asset-transfer-entry-details.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { AssetTransferListComponent } from './asset-transfer-list/asset-transfer-list.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DialogQrAssetDetailsComponent } from './dialog-qr-asset-details/dialog-qr-asset-details.component';
import { DialogPhotosVideosComponent } from './dialog-photos-videos/dialog-photos-videos.component';


@NgModule({
  declarations: [
    AssetTransferEntryLinkComponent,
    AssetTransferEntryLandingPageComponent,
    AssetTransferEntryDetailsComponent,
    AssetTransferListComponent,
    DialogQrAssetDetailsComponent,
    DialogPhotosVideosComponent
  ],
  imports: [
    CommonModule,
    AssetTransferEntryRoutingModule,
    AcademicFormModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    
  ]
})
export class AssetTransferEntryModule { }
